export const ACCESS_TOKEN_LOCAL_STORAGE = 'yheiomdn'
export const LAST_NOTIFICATION_SUBSCRIBE = 'lastNotificationSubscribe'
export const LAST_QUERY_SEARCH_CALENDAR = 'lastQuerySearchCalendar'
export const LOCAL_STORAGE_KEY_BRANCH = '5qot2WBt9jShx76'
export const LOCAL_STORAGE_KEY_LANG = 'lang'
export const DEVICE_ID_KEY = 'app_device_id'
